export default __webpack_public_path__ + "static/media/par3.b5f01ce2.jpg";